import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchActivityCalendar, fetchTaskCount, updateActiveTaskId, updateFilterActiveTab } from "../../../../actions/calendarAction";
import BootstrapTooltip from "../../../globals/BootstrapTooltip";

const FILTER_PLANNED = 0;
const FILTER_OVERDUE = 1;
const FILTER_TODAY = 2;
const FILTER_TOMORROW = 3;
const FILTER_THIS_WEEK = 4;
const FILTER_NEXT_WEEK = 5;

const TASK_ALL = 0;
const TASK_CALL = 1;
const TASK_MEETING = 2;
const TASK_TASK = 3;
const TASK_DEADLINE = 4;
const TASK_EMAIL = 5;
const TASK_FOLLOWUP = 6;

const ActivityTopPanel = (props) => {

    const dispatch = useDispatch();
    const activeTab = useSelector(state => state.calendarReducer.activeTabActivityCalendar);
    const taskCount = useSelector(state => state.calendarReducer.taskCount);
    const filter = useSelector(state => state.calendarReducer.activeFilterId);
    const activeTaskId = useSelector(state => state.calendarReducer.activeTaskId);
    const updateTask = useSelector(state => state.calendarReducer.updateTask);

    const setFilter = (e,filterVal) => {
        e.preventDefault();
        dispatch(updateFilterActiveTab(filterVal));
    }

    const setActiveTaskId = (e,taskId) => {
        e.preventDefault();
        dispatch(updateActiveTaskId(taskId));
    }

    useEffect(() => {
        dispatch(fetchActivityCalendar({
            'task_id' : activeTaskId,
            'activeTab' : activeTab,
            'filter' : filter,
            'contact_id' : props.contactId
        }));
        dispatch(fetchTaskCount({
            'task_id' : activeTaskId,
            'activeTab' : activeTab,
            'contact_id' : props.contactId
        }))
    },[filter,activeTaskId])

    useEffect(() => {
        if(updateTask){
            dispatch(fetchActivityCalendar({
                'task_id' : activeTaskId,
                'activeTab' : activeTab,
                'filter' : filter,
                'contact_id' : props.contactId
            }));
            dispatch(fetchTaskCount({
                'task_id' : activeTaskId,
                'activeTab' : activeTab,
                'contact_id' : props.contactId
            }))
        }
    }, [updateTask])

    return ( 
        <>
        
        <div className="activities_tab_header d-flex align-items-center my-2">
            {/* <a href="#" className="waves-effect bg-gray-light text-dark-blue radius-5 py-2 px-2 mr-1">Today</a> */}
            {/* <a href="#" className="waves-effect bg-gray-light text-dark-blue radius-5 py-2 px-2 d-flex align-items-center mr-1">
                <i className="material-icons mr-1">
                    navigate_before
                </i>
                April 2021
                <i className="material-icons ml-1">
                    navigate_next
                </i>
            </a> */}
            <a href="#!" onClick={e => e.preventDefault()} className="bg-light-blue-10 text-light-blue radius-5 py-2 px-2 d-flex align-items-center mr-1">
                <i className="material-icons mr-2 text-light-blue">
                    watch_later
                </i>
                Today : {taskCount.today !== undefined ? taskCount.today: 0}
            </a>
            <a href="#!" onClick={e => e.preventDefault()} className="bg-red-10 text-red radius-5 py-2 px-2 d-flex align-items-center mr-1">
                <svg className="mr-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.0465 2.95354C16.1228 2.0207 15.0238 1.27956 13.8128 0.772706C12.6018 0.265849 11.3026 0.00326128 9.98984 3.01863e-05C8.67705 -0.00320091 7.37656 0.252988 6.16309 0.753878C4.94961 1.25477 3.84706 1.99049 2.91877 2.91877C1.99049 3.84706 1.25477 4.94961 0.753878 6.16309C0.252988 7.37656 -0.00320091 8.67705 3.01863e-05 9.98984C0.00326128 11.3026 0.265849 12.6018 0.772706 13.8128C1.27956 15.0238 2.0207 16.1228 2.95354 17.0465C3.87725 17.9793 4.97616 18.7204 6.18716 19.2273C7.39816 19.7342 8.69737 19.9967 10.0102 20C11.3229 20.0032 12.6234 19.747 13.8369 19.2461C15.0504 18.7452 16.1529 18.0095 17.0812 17.0812C18.0095 16.1529 18.7452 15.0504 19.2461 13.8369C19.747 12.6234 20.0032 11.3229 20 10.0102C19.9967 8.69737 19.7342 7.39816 19.2273 6.18716C18.7204 4.97616 17.9793 3.87725 17.0465 2.95354ZM13.2031 7.86458C13.4143 7.86458 13.6207 7.9272 13.7963 8.04452C13.9719 8.16184 14.1088 8.32859 14.1896 8.52369C14.2704 8.71879 14.2915 8.93347 14.2503 9.14059C14.2091 9.3477 14.1074 9.53795 13.9581 9.68727C13.8088 9.8366 13.6186 9.93829 13.4114 9.97948C13.2043 10.0207 12.9896 9.99954 12.7945 9.91873C12.5994 9.83791 12.4327 9.70106 12.3154 9.52548C12.198 9.34989 12.1354 9.14346 12.1354 8.93229C12.1351 8.79198 12.1624 8.65298 12.216 8.52328C12.2695 8.39358 12.3481 8.27573 12.4474 8.17652C12.5466 8.0773 12.6644 7.99867 12.7941 7.94513C12.9238 7.8916 13.0628 7.86422 13.2031 7.86458ZM6.79686 7.86458C7.00804 7.86458 7.21447 7.9272 7.39005 8.04452C7.56564 8.16184 7.70249 8.32859 7.7833 8.52369C7.86411 8.71879 7.88526 8.93347 7.84406 9.14059C7.80286 9.3477 7.70117 9.53795 7.55185 9.68727C7.40253 9.8366 7.21228 9.93829 7.00516 9.97948C6.79805 10.0207 6.58337 9.99954 6.38827 9.91873C6.19317 9.83791 6.02641 9.70106 5.90909 9.52548C5.79177 9.34989 5.72915 9.14346 5.72915 8.93229C5.7288 8.79198 5.75618 8.65298 5.80971 8.52328C5.86324 8.39358 5.94188 8.27573 6.04109 8.17652C6.14031 8.0773 6.25815 7.99867 6.38785 7.94513C6.51755 7.8916 6.65655 7.86422 6.79686 7.86458ZM10 11.4236C12.0206 11.4236 13.7259 12.7356 14.2584 14.5302C14.3029 14.6868 14.3621 14.9827 14.3621 14.9827H5.64018C5.64018 14.9827 5.69845 14.685 5.74383 14.5302C6.2679 12.7347 7.97713 11.4236 10 11.4236Z" fill="#FF264A"></path>
                </svg>
                Overdue : {taskCount.overdue !== undefined ? taskCount.overdue: 0}
            </a>
            <a href="#!" onClick={e => e.preventDefault()} className="bg-green-10 text-green radius-5 py-2 px-2 d-flex align-items-center mr-1">
                <i className="material-icons mr-2 text-green">
                    emoji_emotions
                </i>
                Complete: {taskCount.complete !== undefined ? taskCount.complete: 0}
            </a>
            <span className="circle d-flex bg-light-blue justify-content-center align-items-center btn-add-new-activity accent--bg--color"
            onClick={()=>{props.setEditData(null); props.setShowActivityModal(true);}}>
                <i className="material-icons white-text">
                    add
                </i> Add New Activity
            </span> 
        </div>
        <div className="activities_buttons_groups alt d-flex justify-content-between py-2">
            <div className="button_group d-flex align-items-center radius-5">
                <BootstrapTooltip arrow placement="top" title="All">
                    <a href="#!" onClick={e => setActiveTaskId(e,TASK_ALL)} className={`${activeTaskId === TASK_ALL ? 'active' : ''} px-2 d-inline-block white d-flex align-items-center justify-content-center`}>All</a>
                </BootstrapTooltip>
                <BootstrapTooltip arrow placement="top" title="Call">
                    <a href="#!" onClick={e => setActiveTaskId(e,TASK_CALL)} className={`${activeTaskId === TASK_CALL ? 'active' : ''} px-2 d-inline-block white d-flex align-items-center justify-content-center`}>
                        <i className="material-icons text-dark-blue-65">
                            call
                        </i>
                    </a>
                </BootstrapTooltip>
                <BootstrapTooltip arrow placement="top" title="Meeting">
                    <a href="#!" onClick={e => setActiveTaskId(e,TASK_MEETING)} className={`${activeTaskId === TASK_MEETING ? 'active' : ''} px-2 d-inline-block white d-flex align-items-center justify-content-center`}>
                        <i className="material-icons text-dark-blue-65">
                            groups
                        </i>

                    </a>
                </BootstrapTooltip>
                <BootstrapTooltip arrow placement="top" title="Task">
                    <a href="#!" onClick={e => setActiveTaskId(e,TASK_TASK)} className={`${activeTaskId === TASK_TASK ? 'active' : ''} px-2 d-inline-block white d-flex align-items-center justify-content-center`}>
                        <i className="material-icons text-dark-blue-65">
                            task
                        </i>

                    </a>
                </BootstrapTooltip>
                <BootstrapTooltip arrow placement="top" title="Deadline">
                    <a href="#!" onClick={e => setActiveTaskId(e,TASK_DEADLINE)} className={`${activeTaskId === TASK_DEADLINE ? 'active' : ''} px-2 d-inline-block white d-flex align-items-center justify-content-center`}>
                        <i className="material-icons text-dark-blue-65">
                            schedule
                        </i>
                    </a>
                </BootstrapTooltip>
                <BootstrapTooltip arrow placement="top" title="Email">
                    <a href="#!" onClick={e => setActiveTaskId(e,TASK_EMAIL)} className={`${activeTaskId === TASK_EMAIL ? 'active' : ''} px-2 d-inline-block white d-flex align-items-center justify-content-center`}>
                        <i className="material-icons text-dark-blue-65">
                            mail
                        </i>
                    </a>
                </BootstrapTooltip>
                <BootstrapTooltip arrow placement="top" title="Followup">
                    <a href="#!" onClick={e => setActiveTaskId(e,TASK_FOLLOWUP)} className={`${activeTaskId === TASK_FOLLOWUP ? 'active' : ''} px-2 d-inline-block white d-flex align-items-center justify-content-center`}>
                        <i className="material-icons text-dark-blue-65">
                            group_add
                        </i>
                    </a>
                </BootstrapTooltip>
            </div>
            <div className="button_group d-flex align-items-center radius-5 alt">
                <a href="#!" onClick={ e => setFilter(e,FILTER_PLANNED)} className={`${filter === FILTER_PLANNED ? 'active' : ''} text-dark-blue-65 white px-2 bg-light-blue d-flex align-items-center justify-content-center`}>Planned</a>
                <a href="#!" onClick={ e => setFilter(e,FILTER_OVERDUE)} className={`${filter === FILTER_OVERDUE ? 'active' : ''} text-dark-blue-65 white px-2 bg-light-blue d-flex align-items-center justify-content-center`}>Overdue</a>
                <a href="#!" onClick={ e => setFilter(e,FILTER_TODAY)} className={`${filter === FILTER_TODAY ? 'active' : ''} text-dark-blue-65 white px-2 bg-light-blue d-flex align-items-center justify-content-center`}>Today</a>
                <a href="#!" onClick={ e => setFilter(e,FILTER_TOMORROW)} className={`${filter === FILTER_TOMORROW ? 'active' : ''} text-dark-blue-65 white px-2 bg-light-blue d-flex align-items-center justify-content-center`}>Tomorrow</a>
                <a href="#!" onClick={ e => setFilter(e,FILTER_THIS_WEEK)} className={`${filter === FILTER_THIS_WEEK ? 'active' : ''} text-dark-blue-65 white px-2 bg-light-blue d-flex align-items-center justify-content-center`}>This Week</a>
                <a href="#!" onClick={ e => setFilter(e,FILTER_NEXT_WEEK)} className={`${filter === FILTER_NEXT_WEEK ? 'active' : ''} text-dark-blue-65 white px-2 bg-light-blue d-flex align-items-center justify-content-center`}>Next Week</a>
            </div>
        </div>
        </>
        
     );
}
 
export default ActivityTopPanel;